<template>
  <router-view/>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f8fafc;
  min-height: 100vh;
}

body {
  margin: 0;
  background: #f8fafc;
}
</style>

<style>
#app {
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 20px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

nav a {
  font-weight: 600;
  color: #2c3e50;
  text-decoration: none;
  margin: 0 15px;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

nav a:hover {
  background: #f0f0f0;
}

nav a.router-link-exact-active {
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
</style>
